module.exports = __webpack_public_path__ + "static/media/instagram.c9743794.svg";